import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import AddonsServices from '../../services/AddonsServices';
function AddOns() {
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    title: '',
    price: '',
    minutes: '',
    image: '',
  });

  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png'); // Placeholder image path



  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };



  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };
  //   // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      for (const key in formValues) {
        formData.append(key, formValues[key]);
      }

      await AddonsServices.createAddons(formData);
      alert('Addons created successfully');
      navigate('/addons');

    } catch (error) {
      console.error('Failed to create Addons', error);
      alert('Failed to create Addons');
    }
  };

  return (
    <>
      <div className="right_col" role="main">
        <div className="title-box">
          <h2>Addons Add</h2>
          <div className="container-box-top-header-right">
            <Link className="list-banner-btn" to="/addons"> Addons List</Link>
          </div>
        </div>
        <div className="container-box px-5">
          <div className="container-box-inner">
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                <div className="input-field">
                  <label>Title<span className="red">*</span></label>
                  <input type="text" name="title" value={formValues.title} placeholder='Title'
                    onChange={handleInputChange} defaultValue="Product scanning" className="form-control" required />
                </div>
                <div className="input-field">
                  <label>Price<span className="red">*</span></label>
                  <input type="number" name="price" value={formValues.price} placeholder='Price' min="0"
                    step="0"
                    onChange={handleInputChange} defaultValue="Product scanning" className="form-control" required />
                </div>


                <div className="input-field">
                  <label>Minutes</label>
                  <input type="number" name="minutes" value={formValues.minutes}
                    onChange={handleInputChange} defaultValue="Product scanning" className="form-control" required />
                </div>


                <div className="input-field">
                  <label>Upload<span className="red">*</span></label>
                  <input type="file" name="image" className="form-control" onChange={handleFileChange} required />
                  <p><span>Drop an image or Paste URL (up to resolution 1,500 x 1,500 px),</span> Supported formats: png, jpeg, jpg, webp</p>
                  <div className="file-preview text-center">
                    <img id="uploadFile" src={previewImage} alt="your image" />
                  </div>
                </div>
                <button className="submit-green-btn">SUBMIT</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddOns